import Experience from '../Experience';
import * as THREE from 'three';
import gsap from 'gsap';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'

export default class AbridgedCVManager 
{
    constructor(pWorkdenSceneRef)
    {
        this.experienceRef = new Experience();
        this.threeJSsceneRef = this.experienceRef.threeJSscene;
        this.workDenScene = pWorkdenSceneRef;
        this.cameraRef = this.experienceRef.camera;

        // Bind the method so "this" inside onPointerMove refers to the class instance
        this.onPointerMove = this.onPointerMove.bind(this);
        window.addEventListener('pointermove', this.onPointerMove, false);
        this.mouse = new THREE.Vector2();

        this.isCVFocussed = false;        
        this.cvDefaultTransformHolder = new THREE.Object3D();        
        this.cvDefaultTransformHolder.position.copy(this.workDenScene.resumeAbridged.position);
        this.cvDefaultTransformHolder.quaternion.copy(this.workDenScene.resumeAbridged.quaternion);

        // For Debug purposes
        // this.abridgedCvDebugTransformControls = new TransformControls(this.cameraRef.cameraInstance, this.experienceRef.canvas);
        // this.abridgedCvDebugTransformControls.attach(this.workDenScene.resumeAbridged);
        // this.abridgedCvDebugTransformControls.setMode("translate");
        // this.abridgedCvDebugTransformControls.setSpace("local");
        // this.threeJSsceneRef.add(this.abridgedCvDebugTransformControls);
    }

    moveCVtoCamera()
    {
        if (this.cameraRef == null)
        {
            this.cameraRef = this.experienceRef.camera;
        }
        this.cameraRef.cameraState = 'resumeAbridgedFocussed';        
        this.cameraRef.orbitControls.enableDamping = false;
        this.cameraRef.orbitControls.update();
        this.cameraRef.orbitControls.enabled = false;
        
        //Method 1 - using Position and Rotation Vector/Quaternion value holders        
        const cameraForwardDirectionVector = new THREE.Vector3();
        this.cameraRef.cameraInstance.getWorldDirection(cameraForwardDirectionVector); // Get the camera's forward direction
        const targetPositionVector = 
        new THREE.Vector3().copy(this.cameraRef.cameraInstance.position).add(cameraForwardDirectionVector.multiplyScalar(1050));     

        // For TESTING AND DEBUG purposes
        //this.workDenScene.cubeMesh.position.copy(targetPositionVector);

        // Convert world position to local space
        const parent = this.workDenScene.resumeAbridged.parent; // Get parent object
        if (parent) {
            parent.worldToLocal(targetPositionVector);
        }

        /* Method 2 - Object 3D
        this.cvCameraFocusedTransformHolder.position.copy(this.cameraRef.cameraInstance.position);
        this.cvCameraFocusedTransformHolder.quaternion.copy(this.cameraRef.cameraInstance.quaternion);
        this.cvCameraFocusedTransformHolder.translateZ(-1050);
        this.cvCameraFocusedTransformHolder.lookAt(this.cameraRef.cameraInstance.position);
        this.cvCameraFocusedTransformHolder.updateMatrixWorld(true);
        this.cvCameraFocusedTransformHolder.rotateX(Math.PI/12);
        this.cvCameraFocusedTransformHolder.rotateY(Math.PI/2);
        this.cvCameraFocusedTransformHolder.rotateX(Math.PI/2.5);

        //Convert world position to local space
        const parent = this.workDenScene.resumeAbridged.parent; // Get parent object
        if (parent) {
            parent.worldToLocal(this.cvCameraFocusedTransformHolder.position);
            //parent.worldToLocal(this.endPositionObject.quaternion);
        }
        */
        
        /* METHOD 1.a - setting Target Position and Rotation Vectors instantly using Vectors and Quaternions value holders
        
        this.workDenScene.resumeAbridged.position.copy(targetPositionVector);
        this.workDenScene.resumeAbridged.lookAt(this.cameraRef.cameraInstance.position);
        // Apply an extra rotation if the model is misaligned
        this.workDenScene.resumeAbridged.rotateX(Math.PI/2); // Adjust this value if needed
        this.workDenScene.resumeAbridged.updateMatrixWorld(true);
        */

        // METHOD 2.a - Tweening Target Position and Rotation Vectors using Vectors and Quaternions value holders        
        gsap.to(
            this.workDenScene.resumeAbridged.position,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: targetPositionVector.x,
                y: targetPositionVector.y,
                z: targetPositionVector.z,
                onComplete: () => {
                    this.workDenScene.resumeAbridged.lookAt(this.cameraRef.cameraInstance.position);
                    // Apply an extra rotation if the model is misaligned
                    this.workDenScene.resumeAbridged.rotateX(Math.PI/2); // Adjust this value if needed
                    this.workDenScene.resumeAbridged.updateMatrixWorld(true);

                    this.tiltQuat = new THREE.Quaternion();
                    this.baseQuat = this.workDenScene.resumeAbridged.quaternion.clone(); // Save original rotation
                    this.isCVFocussed = true;
                }
            }            
        );        

        /* METHOD 2.b - Tweening Target Position and Rotation Vectors using Object 3D

        gsap.to(
            this.workDenScene.resumeAbridged.position,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvCameraFocusedTransformHolder.position.x,
                y: this.cvCameraFocusedTransformHolder.position.y,
                z: this.cvCameraFocusedTransformHolder.position.z,
                onComplete: () => {
                    this.cvFloatingRotationTransformHolder.position.copy(this.cvCameraFocusedTransformHolder.position);
                    this.isCVFocussed = true;                    
                }
            }            
        );

        gsap.to(
            this.workDenScene.resumeAbridged.rotation,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvCameraFocusedTransformHolder.rotation.x,
                y: this.cvCameraFocusedTransformHolder.rotation.y,
                z: this.cvCameraFocusedTransformHolder.rotation.z,
                onComplete: () => {
                    this.cvFloatingRotationTransformHolder.quaternion.copy(this.cvCameraFocusedTransformHolder.quaternion);                    
                }
            }
        );
        */

        // TESTING AND DEBUG PURPOSES
        // Log the object's world position
        // const worldPosition = new THREE.Vector3();
        // this.workDenScene.resumeAbridged.getWorldPosition(worldPosition);
        // console.log(worldPosition);
        // this.workDenScene.cubeMesh.getWorldPosition(worldPosition);
        // console.log(worldPosition);
    }

    onPointerMove(event)
    {
        // Convert mouse position to normalized device coordinates
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        //console.log("Pointer Moved");

        if (this.isCVFocussed)
        {            
            // Tilt angles
            const tiltX = this.mouse.y * 0.1; // forward/back tilt
            const tiltZ = this.mouse.x * 0.1; // left/right tilt

            // Create a quaternion from local Euler tilt (X and Z axes)
            this.tiltQuat.setFromEuler(new THREE.Euler(tiltX, 0, tiltZ)); // Y is untouched           

            // Combine with original/base rotation (local space)
            this.workDenScene.resumeAbridged.quaternion.copy(this.baseQuat).multiply(this.tiltQuat);
        }
    }

    moveCVtoDefaultPosition()
    {
        this.isCVFocussed = false;
        //this.workDenScene.resumeAbridged.position.copy(this.cvDefaultTransformHolder.position);
        //this.workDenScene.resumeAbridged.quaternion.copy(this.cvDefaultTransformHolder.quaternion);

        gsap.to(
            this.workDenScene.resumeAbridged.position,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvDefaultTransformHolder.position.x,
                y: this.cvDefaultTransformHolder.position.y,
                z: this.cvDefaultTransformHolder.position.z,
                onComplete: () => {
                    this.cameraRef.cameraState = 'default';
                    this.cameraRef.orbitControls.enableDamping = true;
                    this.cameraRef.orbitControls.enabled = true;
                }
            }            
        );

        gsap.to(
            this.workDenScene.resumeAbridged.rotation,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvDefaultTransformHolder.rotation.x,
                y: this.cvDefaultTransformHolder.rotation.y,
                z: this.cvDefaultTransformHolder.rotation.z
            }
        );

    }

    update()
    {
            
    }

    // Function to Center GLTF Mesh Geometry
    centerMeshGeometry(mesh) 
    {
        const box = new THREE.Box3().setFromObject(mesh); // Compute bounding box
        const center = box.getCenter(new THREE.Vector3()); // Get the center of the bounding box
        mesh.position.sub(center); // Offset the mesh to center its geometry
        mesh.updateMatrixWorld(true); // Update the world matrix
  }
}